<template>
  <div class="help-root">
    <div class="help-intro">
      <span class="material-symbols-outlined help-hero-icon">calendar_month</span>
      <p>
        Administra las citas de los pacientes: búsqueda, programación,
        confirmación y seguimiento de estados en un solo lugar.
      </p>
    </div>

    <!-- Búsquedas -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">search</span>
        Búsqueda de citas
      </h3>
      <div class="help-cards">
        <div class="help-card" v-for="item in busquedas" :key="item.titulo">
          <span class="material-symbols-outlined help-card-icon">{{ item.icon }}</span>
          <div>
            <p class="help-card-title">{{ item.titulo }}</p>
            <p class="help-card-desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Estados -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">info</span>
        Estados de una cita
      </h3>
      <div class="help-estados">
        <span
          v-for="e in estados"
          :key="e.label"
          class="help-estado-badge"
          :style="{ background: e.color, color: e.text }"
        >{{ e.label }}</span>
      </div>
    </section>

    <!-- Acciones -->
    <section class="help-section">
      <h3 class="help-section-title">
        <span class="material-symbols-outlined">touch_app</span>
        Acciones disponibles
      </h3>
      <div class="help-actions">
        <div class="help-action" v-for="a in acciones" :key="a.titulo">
          <span class="material-symbols-outlined help-action-icon" :style="{ color: a.color }">{{ a.icon }}</span>
          <div>
            <p class="help-card-title">{{ a.titulo }}</p>
            <p class="help-card-desc">{{ a.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <div class="help-tip">
      <span class="material-symbols-outlined">lightbulb</span>
      <p>La correcta administración de las citas mejora la eficiencia del servicio y la satisfacción del paciente.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "AyudaCita",
  data() {
    return {
      busquedas: [
        { icon: "pending_actions", titulo: "Citas de hoy",    desc: "Pulsa el botón de agenda para cargar automáticamente las citas del médico para el día de hoy." },
        { icon: "badge",           titulo: "Por cédula",      desc: "Ingresa el número de cédula del paciente y presiona Enter para filtrar sus citas." },
        { icon: "person_search",   titulo: "Por nombre",      desc: "Escribe parte del nombre del paciente para buscar todas sus citas asociadas." },
        { icon: "tag",             titulo: "Por número",      desc: "Ingresa el número de cita para acceder directamente al registro." },
        { icon: "filter_list",     titulo: "Por estado",      desc: "Selecciona un estado del listado para ver todas las citas en esa condición." },
      ],
      estados: [
        { label: "PROGRAMADA",   color: "#d4edda", text: "#155724" },
        { label: "CONFIRMADA",   color: "#d1ecf1", text: "#0c5460" },
        { label: "EN PROCESO",   color: "#cce5ff", text: "#004085" },
        { label: "PROCESADA",    color: "#e2e3e5", text: "#383d41" },
        { label: "REPROGRAMADA", color: "#fff3cd", text: "#856404" },
        { label: "CANCELADA",    color: "#f8d7da", text: "#721c24" },
        { label: "AUSENCIA",     color: "#f0f0f0", text: "#555"    },
      ],
      acciones: [
        { icon: "smart_toy",      color: "#0059cc", titulo: "Asistente de citas",     desc: "Haz clic en el ícono del asistente para iniciar el proceso guiado de creación de una nueva cita." },
        { icon: "visibility",     color: "#198754", titulo: "Ver detalle",            desc: "Pulsa el ícono de información en la tabla para ver el resumen completo de la cita." },
        { icon: "event_available",color: "#0dcaf0", titulo: "Confirmar asistencia",   desc: "Cambia el estado a CONFIRMADA para registrar que el paciente asistirá a su cita." },
        { icon: "play_circle",    color: "#6f42c1", titulo: "Iniciar atención",       desc: "Cambia el estado a EN PROCESO para crear automáticamente la atención médica." },
        { icon: "event_repeat",   color: "#fd7e14", titulo: "Reprogramar",            desc: "Cambia el estado a REPROGRAMADA para asignar una nueva fecha y hora al paciente." },
      ],
    };
  },
};
</script>

<style src="@/assets/css/ayuda.css" scoped></style>